import { useMemo } from "react"
import useRequest from "./useRequest"

export default function useSuscripcion() {
  const apiRequest = useRequest();

  return useMemo(() => ({
    // Root
    iniciar: (empresaId, planId) => apiRequest.post('/suscripciones/iniciar', { data: { empresaId, planId } }),
    listar: () => apiRequest.get('/suscripciones'),
    porEmpresa: (empresaId) => apiRequest.get(`/suscripciones/empresa/${empresaId}`),
    ajustar: (empresaId, data) => apiRequest.patch(`/suscripciones/empresa/${empresaId}/ajustes`, { data }),
    // Admin / empresa
    mia: () => apiRequest.get('/suscripciones/mia'),
    // Self-serve: admin de una empresa SIN registro de Suscripciones arranca su
    // propia facturación (sin depender de root). Devuelve { checkoutUrl }.
    iniciarPropia: (planId) => apiRequest.post('/suscripciones/iniciar-propia', { data: { planId } }),
    checkout: () => apiRequest.post('/suscripciones/checkout', { data: {} }),
    confirmarCheckout: (sessionId) => apiRequest.post('/suscripciones/confirmar-checkout', { data: { sessionId } }),
    portal: () => apiRequest.post('/suscripciones/portal', { data: {} }),
    cambiarPlan: (planId) => apiRequest.put('/suscripciones/plan', { data: { planId } }),
    suspender: () => apiRequest.patch('/suscripciones/suspender', { data: {} }),
    cancelar: () => apiRequest.patch('/suscripciones/cancelar', { data: {} }),
    facturas: () => apiRequest.get('/suscripciones/facturas'),
  }), [apiRequest])
}
